(function() {
    function getCmp(id) { return window.sharkDmxCmp ? window.sharkDmxCmp(id) : null; }

    function getOverrides() {
        return getCmp('varGuitarOverrides');
    }

    function getSrvData() { return window.sharkSrvProductData ? window.sharkSrvProductData() : null; }

    function getCurrentParts() {
        var data = getSrvData();
        return (data && data.properties) ? data.properties : [];
    }

    function getPackItems() {
        var data = getSrvData();
        return (data && data.availablePackItems) ? data.availablePackItems : [];
    }

    function rewriteOverrides(newItems) {
        var c = getOverrides();
        if (!c) return;
        // Private _updateData fires one reactive notify; public empty()+concat() fires two and doubles re-renders.
        if (typeof c._updateData === 'function') {
            c._updateData(newItems);
        } else if (c.methods && typeof c.methods.empty === 'function' && typeof c.methods.concat === 'function') {
            c.methods.empty.call(c);
            c.methods.concat.call(c, newItems);
        }
    }

    function setValueCmp(id, value) {
        var c = getCmp(id);
        if (!c) return;
        if (c.methods && typeof c.methods.setValue === 'function') {
            c.methods.setValue.call(c, value);
        } else if (typeof c.set === 'function') {
            c.set('value', value);
        }
    }

    function findCurrentProperty(parentId) {
        var parts = getCurrentParts();
        var pid = Number(parentId);
        for (var i = 0; i < parts.length; i++) {
            var props = parts[i].property || [];
            for (var j = 0; j < props.length; j++) {
                if (Number(props[j].property_parent_id) === pid) {
                    return {
                        design_part_id: Number(parts[i].design_part_id),
                        property_id: Number(props[j].property_id),
                        property_price: Number(props[j].property_price) || 0
                    };
                }
            }
        }
        return null;
    }

    function partCurrentPrice(part) {
        var dpp = (part.design_part_price == null) ? null : Number(part.design_part_price);
        if (dpp != null && !isNaN(dpp)) return dpp;
        var mbp = Number(part.model_base_price);
        return isNaN(mbp) ? 0 : mbp;
    }

    function findCurrentPart(categoryId) {
        var parts = getCurrentParts();
        var cat = Number(categoryId);
        for (var i = 0; i < parts.length; i++) {
            if (Number(parts[i].category_id) === cat) {
                return {
                    design_part_id: Number(parts[i].design_part_id),
                    category_id: Number(parts[i].category_id),
                    model_id: Number(parts[i].model_id),
                    model_base_price: Number(parts[i].model_base_price) || 0,
                    current_price: partCurrentPrice(parts[i])
                };
            }
        }
        return null;
    }

    function findPartByDesignPartId(designPartId) {
        var parts = getCurrentParts();
        var id = Number(designPartId);
        for (var i = 0; i < parts.length; i++) {
            if (Number(parts[i].design_part_id) === id) return parts[i];
        }
        return null;
    }

    function packConfig(packType) {
        var isPickup = (packType === 'pickup');
        return {
            categories: isPickup ? [16, 17] : [20, 21, 24],
            packVarId: isPickup ? 'varGuitarPickupPack' : 'varGuitarFXPack',
            customizeVarId: isPickup ? 'varGuitarPickupCustomize' : 'varGuitarFXCustomize'
        };
    }

    function autoDetectPack(packType) {
        var cfg = packConfig(packType);
        var packCategories = cfg.categories;
        var parts = getCurrentParts();
        var packItems = getPackItems();
        var currentMap = {};
        var presentCats = [];
        for (var i = 0; i < parts.length; i++) {
            var cat = Number(parts[i].category_id);
            if (packCategories.indexOf(cat) >= 0) {
                currentMap[cat] = Number(parts[i].model_id);
                presentCats.push(cat);
            }
        }
        if (presentCats.length === 0) return;
        var packs = {};
        for (var j = 0; j < packItems.length; j++) {
            var pid = Number(packItems[j].pack_id);
            var pcat = Number(packItems[j].category_id);
            if (packCategories.indexOf(pcat) < 0) continue;
            if (!packs[pid]) packs[pid] = {};
            packs[pid][pcat] = Number(packItems[j].model_id);
        }
        var matchedPackId = null;
        for (var pkId in packs) {
            var packMap = packs[pkId];
            var packCats = Object.keys(packMap).map(Number);
            if (packCats.length !== presentCats.length) continue;
            var allMatch = true;
            for (var k = 0; k < presentCats.length; k++) {
                if (packMap[presentCats[k]] !== currentMap[presentCats[k]]) {
                    allMatch = false;
                    break;
                }
            }
            if (allMatch) { matchedPackId = pkId; break; }
        }
        if (matchedPackId !== null) {
            setValueCmp(cfg.packVarId, String(matchedPackId));
        }
    }

    window.initGuitarDefaults = function() {
        autoDetectPack('pickup');
        autoDetectPack('fx_card');
    };

    function findNeckDesignPartId() {
        var parts = getCurrentParts();
        for (var i = 0; i < parts.length; i++) {
            if (Number(parts[i].category_id) === 11) return Number(parts[i].design_part_id);
        }
        return null;
    }

    window.setGuitarProperty = function(parentId, selectedPropertyId, selectedDelta) {
        var c = getOverrides();
        if (!c) return;
        var current = findCurrentProperty(parentId);
        var pid = Number(parentId);
        var selected = (selectedPropertyId === '' || selectedPropertyId == null) ? null : Number(selectedPropertyId);
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = items.filter(function(it) {
            return !(it.override_type === 'property' && Number(it.property_parent_id) === pid);
        });
        if (selected !== null && (current === null || selected !== current.property_id)) {
            var designPartId = current ? current.design_part_id : findNeckDesignPartId();
            if (designPartId !== null) {
                filtered.push({
                    design_part_id: designPartId,
                    override_type: 'property',
                    property_parent_id: pid,
                    property_id: selected,
                    pack_id: null,
                    delta_price: Number(selectedDelta) || 0
                });
            }
        }
        rewriteOverrides(filtered);
    };

    // The single source of truth for "what this build currently is": the stored parts with
    // every pending Quick Config override folded in. The spec sheet and the 3D scene both
    // read this, so they can never disagree with the readout or the price.
    window.getEffectiveGuitarParts = function () {
        var data = getSrvData();
        var parts = (data && data.properties) || [];
        var component = getOverrides();
        var overrides = (component && component.data && component.data.items) || [];
        if (!parts.length || !overrides.length) return parts;
        var options = (data && data.availableProperties) || [];
        var swaps = (data && data.availableSwaps) || [];
        return parts.map(function (part) {
            var mine = overrides.filter(function (item) { return Number(item.design_part_id) === Number(part.design_part_id); });
            if (!mine.length) return part;
            var copy = Object.assign({}, part);
            copy.property = (part.property || []).map(function (row) { return Object.assign({}, row); });
            mine.forEach(function (item) {
                if (item.override_type === 'property') {
                    var row = copy.property.find(function (candidate) { return Number(candidate.property_parent_id) === Number(item.property_parent_id); });
                    if (!row) return;
                    var option = options.find(function (candidate) { return Number(candidate.property_id) === Number(item.property_id); });
                    // A stale override whose option has since been retired must not leave the row
                    // carrying the new id next to the old name and price — that mixture is what
                    // the spec sheet and the 3D scene would then render as truth.
                    if (!option) return;
                    row.property_id = Number(item.property_id);
                    // property_name on a stored row is the ATTRIBUTE name and must survive;
                    // design_part_property_value is the chosen option.
                    row.design_part_property_value = option.property_name;
                    row.property_price = option.property_price;
                    if (option.property_json_key) row.property_json_key = option.property_json_key;
                    if (option.property_json_value != null) row.property_json_value = option.property_json_value;
                    return;
                }
                if (item.override_type === 'model') {
                    var swap = swaps.find(function (candidate) { return Number(candidate.model_id) === Number(item.override_model_id); });
                    if (!swap) return;
                    copy.model_id = Number(item.override_model_id);
                    copy.part_name = swap.model_name;
                    copy.model_type = swap.model_type;
                    copy.model_base_price = swap.model_base_price;
                }
            });
            return copy;
        });
    };

    function findPropertyOnPart(part, parentId) {
        var rows = (part && part.property) || [];
        for (var i = 0; i < rows.length; i++) {
            if (Number(rows[i].property_parent_id) === Number(parentId)) {
                return {
                    property_id: Number(rows[i].property_id),
                    property_price: Number(rows[i].property_price) || 0
                };
            }
        }
        return null;
    }

    window.setGuitarPropertyOnPart = function(categoryId, parentId, selectedPropertyId, selectedDelta) {
        var c = getOverrides();
        if (!c) return;
        var parts = getCurrentParts();
        var part = null;
        for (var i = 0; i < parts.length; i++) {
            if (Number(parts[i].category_id) === Number(categoryId)) { part = parts[i]; break; }
        }
        if (!part) return;
        var designPartId = Number(part.design_part_id);
        var pid = Number(parentId);
        var current = findPropertyOnPart(part, pid);
        var selected = (selectedPropertyId === '' || selectedPropertyId == null) ? null : Number(selectedPropertyId);
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = items.filter(function(it) {
            return !(it.override_type === 'property' && Number(it.property_parent_id) === pid && Number(it.design_part_id) === designPartId);
        });
        if (selected !== null && (current === null || selected !== current.property_id)) {
            filtered.push({
                design_part_id: designPartId,
                override_type: 'property',
                property_parent_id: pid,
                property_id: selected,
                pack_id: null,
                delta_price: Number(selectedDelta) || 0
            });
        }
        rewriteOverrides(filtered);
    };

    window.setGuitarModel = function(categoryId, selectedModelId, selectedBasePrice) {
        var c = getOverrides();
        if (!c) return;
        var current = findCurrentPart(categoryId);
        if (!current) return;
        var selected = (selectedModelId === '' || selectedModelId == null) ? null : Number(selectedModelId);
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = items.filter(function(it) {
            return !(it.override_type === 'model' && Number(it.design_part_id) === current.design_part_id);
        });
        if (selected !== null && selected !== current.model_id) {
            filtered.push({
                design_part_id: current.design_part_id,
                override_type: 'model',
                override_model_id: selected,
                pack_id: null,
                delta_price: (Number(selectedBasePrice) || 0) - current.current_price
            });
        }
        rewriteOverrides(filtered);
    };

    window.setGuitarPack = function(packType, selectedPackId) {
        var c = getOverrides();
        if (!c) return;
        var cfg = packConfig(packType);
        var packId = (selectedPackId === '' || selectedPackId == null) ? null : Number(selectedPackId);
        var packCategories = cfg.categories;
        var packItems = getPackItems();
        var parts = getCurrentParts();
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = items.filter(function(it) {
            if (it.override_type !== 'model') return true;
            var part = findPartByDesignPartId(it.design_part_id);
            if (!part) return true;
            return packCategories.indexOf(Number(part.category_id)) < 0;
        });
        if (packId !== null) {
            for (var i = 0; i < packItems.length; i++) {
                if (Number(packItems[i].pack_id) !== packId) continue;
                var part = null;
                for (var k = 0; k < parts.length; k++) {
                    if (Number(parts[k].category_id) === Number(packItems[i].category_id)) {
                        part = parts[k];
                        break;
                    }
                }
                if (!part) continue;
                filtered.push({
                    design_part_id: Number(part.design_part_id),
                    override_type: 'model',
                    override_model_id: Number(packItems[i].model_id),
                    pack_id: packId,
                    delta_price: (Number(packItems[i].model_base_price) || 0) - partCurrentPrice(part)
                });
            }
        }
        setValueCmp(cfg.customizeVarId, false);
        setValueCmp(cfg.packVarId, packId === null ? '' : String(packId));
        rewriteOverrides(filtered);
    };

    window.expandGuitarPackToCustom = function(packType) {
        var c = getOverrides();
        if (!c) return;
        var cfg = packConfig(packType);
        var packCategories = cfg.categories;
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var updated = items.map(function(it) {
            if (it.override_type !== 'model') return it;
            var part = findPartByDesignPartId(it.design_part_id);
            if (!part) return it;
            if (packCategories.indexOf(Number(part.category_id)) < 0) return it;
            return {
                design_part_id: it.design_part_id,
                override_type: 'model',
                override_model_id: it.override_model_id,
                pack_id: null,
                delta_price: it.delta_price
            };
        });
        setValueCmp(cfg.packVarId, '');
        setValueCmp(cfg.customizeVarId, true);
        rewriteOverrides(updated);
    };

    window.clearGuitarCustomize = function(packType) {
        var c = getOverrides();
        if (!c) return;
        var cfg = packConfig(packType);
        var packCategories = cfg.categories;
        var items = (c.data && c.data.items) ? c.data.items.slice() : [];
        var filtered = items.filter(function(it) {
            if (it.override_type !== 'model') return true;
            var part = findPartByDesignPartId(it.design_part_id);
            if (!part) return true;
            return packCategories.indexOf(Number(part.category_id)) < 0;
        });
        setValueCmp(cfg.customizeVarId, false);
        setValueCmp(cfg.packVarId, '');
        rewriteOverrides(filtered);
    };
})();
